export default ({ colors }) => ({
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '60vh',
    padding: '2rem 1rem',
    backgroundColor: '#f8f9fa'
  },
  content: {
    textAlign: 'center',
    maxWidth: '620px',
    width: '100%',
    padding: '3rem 2.5rem',
    backgroundColor: '#ffffff',
    borderRadius: '12px',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
    border: '1px solid #e5e7eb'
  },
  iconWrapper: {
    marginBottom: '1.5rem',
    display: 'flex',
    justifyContent: 'center'
  },
  warningIcon: {
    width: '60px',
    height: '60px'
  },
  title: {
    fontSize: '1.25rem',
    fontWeight: '600',
    color: '#1f2937',
    marginBottom: '1rem',
    marginTop: '0',
    lineHeight: '1.5'
  },
  subtitle: {
    fontSize: '0.95rem',
    color: '#6b7280',
    marginBottom: '1.5rem',
    lineHeight: '1.5'
  },
  button: {
    backgroundColor: '#2563eb',
    color: '#ffffff',
    border: 'none',
    borderRadius: '6px',
    padding: '0.75rem 2rem',
    fontSize: '1rem',
    fontWeight: '500',
    cursor: 'pointer',
    marginBottom: '2rem',
    transition: 'background-color 0.2s',
    ':hover': {
      backgroundColor: '#1d4ed8'
    },
    ':active': {
      backgroundColor: '#1e40af'
    }
  },
  tipSection: {
    marginTop: '2rem',
    paddingTop: '1.5rem',
    borderTop: '1px solid #e5e7eb'
  },
  tipLabel: {
    fontSize: '0.9rem',
    fontWeight: '600',
    color: '#1f2937',
    marginBottom: '0.5rem',
    textAlign: 'left'
  },
  tipText: {
    fontSize: '0.875rem',
    color: '#6b7280',
    marginBottom: '1rem',
    lineHeight: '1.5',
    textAlign: 'left'
  },
  linkContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '0.5rem',
    flexWrap: 'wrap',
    fontSize: '0.875rem'
  },
  link: {
    color: '#4b5563',
    wordBreak: 'break-all',
    textAlign: 'center'
  },
  copyLink: {
    color: '#2563eb',
    cursor: 'pointer',
    textDecoration: 'underline',
    fontWeight: '500',
    ':hover': {
      color: '#1d4ed8'
    }
  }
})



// WEBPACK FOOTER //
// ./components/blockedAccess/styles.js